/**
 * Event listener for when the document is ready.
 * WordPress and jQuery compatible version with NO ES6 exports.
 * This serves as replacement for jQuery's `$(document).ready()` function.
 *
 * @see http://youmightnotneedjquery.com/#ready
 *
 * @param {Function} callback the function to call when the DOM is ready
 */
(function (global) {
  "use strict";

  const onDocumentReady = (callback) => {
    if (!callback || typeof callback !== "function") {
      return;
    }

    // If document is already ready
    if (document.readyState !== "loading") {
      // Use setTimeout to ensure it runs after current call stack
      setTimeout(callback, 0);
    } else {
      // Listen for DOMContentLoaded
      document.addEventListener("DOMContentLoaded", callback, { once: true });
    }
  };

  // Make available globally (WordPress compatible)
  global.onDocumentReady = onDocumentReady;

  // Also make available as CommonJS module if needed
  if (typeof module !== "undefined" && module.exports) {
    module.exports = onDocumentReady;
  }
})(typeof window !== "undefined" ? window : this);
